const secrets = {
    third_party_token_set: {
        token_not_found: 'ไม่พบข้อมูล Token',
        access_token_expired: 'Access token หมดอายุแล้ว กรุณาเชื่อมต่อบัญชีของคุณใหม่',
    },
};
export default Object.freeze(secrets);
